import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import React, { Reducer, useContext, useEffect, useReducer } from 'react'
import { useHistory, useParams } from 'react-router'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import { 
  GetStatisticMappingExternalDocument,
  PosPermission,
  useGetOutletQuery,
  useGetStatisticExternalMappingAndOutletStatisticQuery,
  useGetStatisticMappingExternalQuery,
  useOutletStatisticMappingInsertMutation,
  useSubmitStatisticMappingExternalMutation,
} from 'generated/graphql';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg'
import { usePermissionChecker } from 'helpers/hooks/usePermissionChecker'
import { IAction } from 'helpers/model'
import { useSnackBar } from 'helpers/hooks/useSnackBar'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { SystemMsgs } from 'helpers/SystemMsg'
import { Grid, ListItem, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, useMediaQuery } from '@material-ui/core'
import theme from '@ifca-root/react-component/src/assets/theme'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { AddBox, IndeterminateCheckBox } from '@material-ui/icons'
import useStyles from 'containers/AccountModule/useStyles'


type Mode = 'edit' | 'save'
interface props {
	outletID: string;
	statisticType: string;
  description: string;
	accountCode: string;
	division: string;
  department: string;
  displaySeq: number;
  mode?: Mode;
  StatisticsJournalType: string;

}

interface StatisticFieldProps {
	statisticItems: any;
}
export const StatisticMapping = () => {
  let history = useHistory()
  const { handlePermDisabled } = usePermissionChecker()

  const initialState: props = {
    outletID: '',
    statisticType: '',
    description: '',
    accountCode: '',
    division: '',
    department: '',
    displaySeq: 0,
    mode:'edit',
    StatisticsJournalType:'MXST'
  }
  const { [`outletID`]: outletID } = useParams<Record<string, any>>();

  console.log()
  initialState.outletID = outletID;
  const {
      register,
      control,
      handleSubmit,
      setError,
      errors,
      clearErrors,
      watch,
      formState: { isSubmitting },
    } = useForm<StatisticFieldProps>({
      defaultValues: {},
      mode: 'onSubmit',
      // resolver: yupResolver(TableSchema),
    });
    
  const { fields, append, remove, insert, prepend } = useFieldArray({
        control,
        name: 'statisticItems',
      });

  const reducer: Reducer<props, IAction> = (state, action) => {
    switch (action.type) {
      case 'reset':
        return initialState
      default:
        return { ...state, [action.type]: action.payload }
    }
  }
  
	const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
		SnackBarContext as any,
	);
 
  const [state, dispatch] = useReducer(reducer, initialState)
  const outletid = localStorage.getItem('latestOutlet')


  const { loading: outletLoading, refetch: outletRefetch, data: { getOutlet } = { getOutlet: [] } } = useGetOutletQuery({
    fetchPolicy: 'network-only',
    onCompleted: (data:any) => {
       dispatch({
        type: 'StatisticsJournalType',
        payload: getOutlet[0]?.StatisticsJournalType ||'MXST'
      })
      // dispatch({ type: 'Statistic', payload: handleReturnStatistic() })		  	
    },
    variables: { ID: localStorage.getItem('latestOutlet') },
  });

  console.log(getOutlet,'getOutlet')

  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

      const [
        submitStatisticMappingExternal,
        {
          data: createdStatisticMappingExternalData,
          loading: createStatisticMappingExternalLoading,
          called: createStatisticMappingExternalCalled,
          error: createStatisticMappingExternalError,
        },
      ] = useSubmitStatisticMappingExternalMutation({
        onError: error => {
          console.log('Suberror', error);
        },
        onCompleted: data => {
          setOpenSnackBar(true);
          setSnackBarMsg(SystemMsgs.createNewRecord());
          // setTimeout(() => {
          //   history.push({
          //     pathname: `/menu/outlet-app/outlet-setting/${outletID}/table`,
          //     state: { success: true, msgMode: 'create' },
          //   });
          // }, 500);
          // window.location.reload();
        },
      });
      const 
        {
          refetch:getStatisticExternalMappingAndOutletStatistiRefetch,
          data: { getStatisticExternalMappingAndOutletStatistic } = { getStatisticExternalMappingAndOutletStatistic: [] },
          loading: statisticExternalMappingAndOutletLoading,
          called: statisticExternalMappingAndOutletCalled,
          error: statisticExternalMappingAndOutletError,
        }
       = useGetStatisticExternalMappingAndOutletStatisticQuery({
        fetchPolicy: 'no-cache',
		    variables: { outletID: outletid },
        onError: error => {
          console.log('Suberror', error);
        },
        onCompleted: data => {
          let temp = [];
          for (const v of data?.getStatisticExternalMappingAndOutletStatistic) {
            temp.push({
              outletID: v.outletID,
              ID: v.statisticMappingID,
              accountCode: v.accountCode,
              department: v.department,
              division: v.division,
              statisticType: v.statisticType,
              displaySeq: v.displaySeq,
              description : v.description,
              isInUse: v.isInUse,
            });
          }
          remove();
          append(temp);
        },
      });
  const [OutletStatisticMappingInsert, { loading: statisticLoading }] = useOutletStatisticMappingInsertMutation({})


  const onSubmit = async (data: any) => {
    console.log(data,'statisticv')
    const tables: any[] = data?.statisticItems;
    const finalInput = tables?.map((v: any, index) => {
      const accountCodeCleaned = v?.accountCode.replace(/\s+/g, "")
      const divisionCleaned = v?.division.replace(/\s+/g, "")
      const departmentCleaned = v?.department.replace(/\s+/g, "")
      console.log(v,data,'statisticv')
      return {
        outletID: outletid,
        ID: v?.ID,
        statisticType: v?.statisticType,
        description : v?.description,
        accountCode: accountCodeCleaned,
        division:divisionCleaned,
        department: departmentCleaned,
        displaySeq: index + 1,
      };
    });

    submitStatisticMappingExternal({
      variables: { input: finalInput, outletID: outletid, StatisticsJournalType: state?.StatisticsJournalType },
      refetchQueries: [
        {
        query:GetStatisticMappingExternalDocument,
          variables: {
            outletID: outletid,
          },
        },
      ],
    }).then(i => {
          if (i?.data?.submitStatisticMappingExternal) {
            setOpenSnackBar(true);
            setSnackBarMsg(SystemMsgs.updateRecord());
            getStatisticExternalMappingAndOutletStatistiRefetch();
          } else {
            setOpenSnackBar(true);
            setSnackBarMsg(SystemMsgs.createNewRecord());
            getStatisticExternalMappingAndOutletStatistiRefetch();
          }
        });
  };
	const classes = useStyles();
  return (
    <>
      {createStatisticMappingExternalLoading && <Loading />}
      {statisticExternalMappingAndOutletLoading && <Loading />}
      {outletLoading && <Loading />}
      <MainHeader
        onClick={() => history.push('/menu/outlet-app/account-journals/account-mapping')}
        mainBtn="back"
        smTitle="Outlet App"
        title={getOutlet[0]?.name}
        routeSegments={[
          { name: 'Account Mapping' },
          { name: 'Statistic Mapping', current: true },
        ]}
      />

        <ContentWrapper 
          tableHeader
          style={{
            // marginTop: '84px',
            padding: '25px 8px 120px',
            // top: '65px',
          }}
        >
        <TableContainer style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Table className={classes.table} aria-label="simple table">
            <TableBody className="mapping-table">
              <TableRow className="mapping-tr">
              <TableCell component="th" scope="row">
                <span className="xsTitle ">Journal Type</span>
              </TableCell>
                    <TableCell align="left">
                      {state.mode === 'edit' ? (
                        state?.StatisticsJournalType
                      ) : (
                        <TextField
                          id="outlined-basic"
                          // value={state?.JournalType}
                          defaultValue={getOutlet[0]?.StatisticsJournalType || 'MXST'}
                          placeholder={state?.StatisticsJournalType}
                          className="mapping-textfield"
                          variant="outlined"
                          onChange={e => {
                              const cleaned = e.target.value.replace(/\s+/g, "");
                            console.log(cleaned, "cleaned"); // should have no spaces
                            dispatch({
                              type: 'StatisticsJournalType',
                              payload: cleaned, // remove all spaces,
                            })}
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell align="left">
                      <span className="xsTitle  title-row">-</span>{' '}
                    </TableCell>
                    <TableCell align="left">
                      <span className="xsTitle title-row">-</span>{' '}
                    </TableCell>
                    <TableCell align="left">
                      <span className="xsTitle title-row">-</span>
                    </TableCell>
                    <TableCell align="left">
                      <span className="xsTitle title-row">-</span>
                    </TableCell>
               </TableRow>
              <TableRow className="mapping-tr">
                <TableCell className="header-bg table-row-sticky">
                    Outlet
                </TableCell>
                <TableCell className="header-bg" align="center">
                    Statistic
                  </TableCell>
                   <TableCell className="header-bg" align="center">
                  Division
                  </TableCell>
                  <TableCell className="header-bg" align="center">
                  Department
                  </TableCell>
                  <TableCell className="header-bg" align="center">
                  Account Code
                  </TableCell>
                  <TableCell className="header-bg" align="center">
                  {state.mode === 'edit' ? (
                  <span className="xxTitle fw-medium">
                </span>
              ) :(
                <AddBox
                  style={{ color: '#faf2e8' }}
                  onClick={() => {
                    if (fields.length < 100) { // Assuming 'fields' is your array holding the appended items
                      append({
                        ID: '00000000-0000-0000-0000-000000000000',
                        statisticType: 'External',
                        description: '',
                        accountCode: '',
                        division: '',
                        department: '',
                      });
                    } 
                  }}
                />
      )}
                  </TableCell>
              </TableRow>
              {fields?.sort((a, b) => a.displaySeq - b.displaySeq).map((v, index) => {
        const statisticItems = `statisticItems[${index}]`;
        return ( // Added 'return' here
          <TableRow className="mapping-tr" key={v.id}>
            <Controller
              render={({ onChange, onBlur, value }) => null}
              name={`${statisticItems}.ID`}
              key={v?.ID}
              value={v?.ID}
              required
              ref={register}
              control={control}
              defaultValue={v?.ID}
            />
            <Controller
              render={({ onChange, onBlur, value }) => null}
              name={`${statisticItems}.statisticType`}
              key={v?.ID}
              value={v?.statisticType}
              required
              ref={register}
              control={control}
              defaultValue={v?.statisticType}
            />
            <TableCell scope="row" style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}> 
              {getOutlet[0]?.name}
            </TableCell>
            <TableCell align="left">
              {state.mode === 'edit' ? (
                v?.description
              ) : (
                <Controller
                  as={TextField}
                  name={`${statisticItems}.description`}
                  disabled={v?.isInUse === true || v?.statisticType !== 'External'}
                  autoComplete="off"
                  className="mapping-textfield"
                  key={v?.ID}
                  required
                  fullWidth
                  ref={register}
                  control={control}
                  defaultValue={v?.description}
                  variant="outlined"
                  style={{ width: '80%' }}
                  error={Boolean(errors?.statisticItems?.[index]?.description)}
                  helperText={errors?.statisticItems?.[index]?.description?.message}
                />
              )}
            </TableCell>
             <TableCell align="left">
              {state.mode === 'edit' ? (
                v?.division
              ) : (
                <Controller
                  as={TextField}
                  name={`${statisticItems}.division`}
                  autoComplete="off"
                  className="mapping-textfield"
                  key={v?.ID}
                  required
                  fullWidth
                  ref={register}
                  control={control}
                  defaultValue={v?.division}
                  variant="outlined"
                  style={{ width: '80%'}}
                  error={Boolean(errors?.statisticItems?.[index]?.division)}
                  helperText={errors?.statisticItems?.[index]?.division?.message}
                />
              )}
            </TableCell>
            <TableCell align="left">
              {state.mode === 'edit' ? (
                v?.department
              ) : (
                <Controller
                  as={TextField}
                  name={`${statisticItems}.department`}
                  autoComplete="off"
                  className="mapping-textfield"
                  key={v?.ID}
                  required
                  fullWidth
                  ref={register}
                  control={control}
                  defaultValue={v?.department}
                  variant="outlined"
                  style={{ width: '80%'}}
                  error={Boolean(errors?.statisticItems?.[index]?.department)}
                  helperText={errors?.statisticItems?.[index]?.department?.message}
                />
              )}
            </TableCell>
            <TableCell align="left">
              {state.mode === 'edit' ? (
                v?.accountCode
              ) : (
                <Controller
                  as={TextField}
                  name={`${statisticItems}.accountCode`}
                  autoComplete="off"
                  className="mapping-textfield"
                  key={v?.ID}
                  required
                  fullWidth
                  ref={register}
                  control={control}
                  defaultValue={v?.accountCode}
                  variant="outlined"
                  style={{ width: '80%'}}
                  error={Boolean(errors?.statisticItems?.[index]?.accountCode)}
                  helperText={errors?.statisticItems?.[index]?.accountCode?.message}
                />
              )}
            </TableCell>
            <TableCell align="left">
              {state.mode !== 'edit' && v?.statisticType === 'External' && (
               <IndeterminateCheckBox
                  style={{
                    color: v?.isInUse ? '#bdbdbd' : 'red',
                    paddingLeft: '25px',
                    cursor: v?.isInUse ? 'not-allowed' : 'pointer',
                    opacity: v?.isInUse ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (v?.isInUse) {
                      setOpenSnackBar(true);
                      setSnackBarMsg('Record already in use.');
                      return;
                    }
                    remove(index);
                  }}
               />
              )}
            </TableCell>
          </TableRow>
        );
      })}

            </TableBody>
          </Table>
        </TableContainer>
        </ContentWrapper>

      <Footer
        options={[
          {
            name: state.mode === 'edit' ? 'Edit' : 'Save',
            onClick: () => {
              dispatch({
								type: 'mode',
								payload: state.mode === 'edit' ? 'save' : 'edit',
							});
              state.mode === 'save' && handleSubmit(onSubmit)()
            },
            color: 'primary',
            disabled: handlePermDisabled({
              outletID: localStorage.getItem('latestOutlet'),
              permEnum: PosPermission.AccountJournalsAccountsMappingStatisticInterfaceUpdate,
            }),
          },
        ]}
      />
    </>
  )
}